export default __webpack_public_path__ + "static/media/cat10.d78591db.gif";